export const RADIO_OPTIONS_ARRAY_YES_NO = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];
export const RADIO_OPTIONS_ARRAY_TRUE_FALSE = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
];
